module.exports = __webpack_public_path__ + "static/img/banner1.75f15795.png";